import RegisterPartnerV2 from './register-partner-v2-container';

export default RegisterPartnerV2;
